
<article>
  <div class="flex gap-4 justify-between h-[222px]">
  
    <div class="w-full flex flex-col justify-between">
      <h5 class="product-title">
        {{ product.name }}
      </h5>
      <p v-if="pricingActive" class="product-price">
        <span v-if="product.classification === 'container_rental'">
          <!--from-->
          {{ dollars(priceBookEntry.priceCents) }}/month
          <!--<i>&plus; Tax, Delivery  &amp; Pickup</i>-->
        </span>
        <span v-else>
          <!--from-->
          {{ dollars(priceBookEntry.priceCents) }}
          <!--<i class="is-size-7">&plus; Tax &amp; Delivery</i>-->
        </span>
      </p>

      <div class="flex gap-1">
        <a :href="productURL()" class="view-product">
          View Product Page
        </a>
        <img src="@/images/quote-builder/chevron_right.svg" alt="View product">
      </div>
    </div>
    
    <div class="w-full flex justify-center items-center" style="position: relative">
      <figure v-if="product.primaryPhoto" class="image product-figure">
        <img :src="imageUrl(product.primaryPhoto.key, { resize: { width: auto, height:170  } } )">
      </figure>
      <quote-quantity :price-book-entry="priceBookEntry" class="quote-quantity" />
    </div>

  </div>
</article>
